import axios from 'axios';

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API; 

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

export const API_ENDPOINTS = {
  galery: '/api/gallery',
  menu:{
    restaurant: '/api/menu/restaurant',
    dailyDish: '/api/menu/daily-dish'
  },
  slider: '/api/carousel',
  reservation: '/api/reservation',
  contact: '/api/contact',
  allergen: '/api/allergen',
  businessHours: {
    list: '/api/business-hours',
    availability: '/api/business-hours/availability',
    closedDates: '/api/business-hours/closed-dates'
  }
};

